<template>
  <div class="content">
    <commonHeader diyHeaderColor="#4A44C6" pageTitle="OrderStatus"></commonHeader>
    <div class="orderInfo">
      <template>
        <img src="@/assets/issuedBG.png" alt="" v-if="status === '170'" />
        <img src="@/assets/underReviewBG.png" alt="" v-if="status === '90'" />
        <img src="@/assets/issuingBG.png" alt="" v-if="status === '150'" />
        <img src="@/assets/approvedBG.png" alt="" v-if="status === '100'" />
      </template>
      <template>
        <p class="orderTitle" v-if="status === '90'">Order auditing</p>
        <p class="orderTitle" v-if="status === '150'">Order issuing</p>
        <p class="orderTitle" v-if="status === '100'">Order approved</p>
        <p class="orderTitle" v-if="status === '170'">Order issued</p>
      </template>
    </div>
    <div class="mian">
      <div class="productInfo">
        <van-skeleton title avatar :loading="loading">
          <img
            :src="img"
            class="orderIcon"
            alt=""
          />
        </van-skeleton>
        <div class="productName">
          {{ productName }}
        </div>
      </div>
      <div class="loanDetails">
        <div class="box-name">Loan Details:</div>
        <div class="numBox" v-for="(item, index) in list" :key="index">
          <div class="num-left">{{ item.resume }}</div>
          <div class="num-right" v-html="item.survival"></div>
        </div>
        <!-- <div
          v-if="status === '170'"
          @click="loan('Loan Agreement')"
          class="loanAgreement">
          See loan contract
        </div> -->
      </div>
      <div
        class="bottom-btn"
        v-if="status === '170'"
        @click="gonormalExtension"
      >
        Repay
      </div>
    </div>
  </div>
</template>

<script>
import { Toast } from "vant";
import { base64ToImage } from "@/utils/baseImg";
import { getOrderDetails } from "@/views/order/lib";
import commonHeader from '@/components/commonHeader.vue'

export default {
  name: "orDer",
  components: { commonHeader },
  data() {
    return {
      title: "orDer",
      orderNo: localStorage.getItem("orderNo") || "",
      productName: null,
      loading: false,
      img: null,
      status: null,
      type: null,
      list: [],
    };
  },
  methods: {
    async getOrderDetails() {
      const loadingInstance = Toast.loading({
        message: "Loading...",
        duration: 0, // 设置为 0 表示持续加载直到手动关闭
        forbidClick: true, // 防止用户点击
        closeOnClick: false, // 设置为 true 可以点击关闭 loading
      });
      const res = await getOrderDetails({
        pageType: 1,

        orderNo: this.orderNo,
      });
      console.log(res, "订单详情");
      if (res.authority === "200") {
        this.status = res.same.enact;
        loadingInstance.clear();
        (this.loading = false), (this.list = res.same.patron);
        this.productName = res.same.glad;
        this.img = 
        res.same.dish ? 
        base64ToImage(`${"data:image/png;base64," + res.same.dish}`)
        : require('@/assets/common/defaultOrderImg.png');
        if (this.status === "90") {
          this.type = "AUDITING";
        } else if (this.status === "100") {
          this.type = "APPROVED";
        } else if (this.status === "150") {
          this.type = "ISSUING";
        } else if (this.status === "170") {
          this.type = "ISSUED";
        }
        this.$managementEvents({
          pageName: "gender",
          action: "everything",
          extInfo: { type: this.type, loanOrderId: this.orderNo },
        });
      }
    },
    // 借款协议
    loan(name) {
      this.$router.push({ name: "AgreeMent", query: { name } });
    },
    //去到期还款页面
    gonormalExtension() {
      this.$router.replace("normalExtension");
    },
  },
  mounted() {
    this.getOrderDetails();
  },
  created() {},
};
</script>

<style lang="less" scoped>
.content {
  width: 100%;
  height: 100vh;
  background: #4A44C6;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  overflow: auto;
  padding-top: 55px;
  .orderInfo {
    width: 100%;
    height: 44px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    margin-bottom: 10px;
    img {
      width: 44px;
      position: absolute;
      top: 0;
      left: 16px;
    }
    .orderTitle {
      color: #ffffff;
      font-size: 18px;
      font-weight: bold;
    }
  }

  .mian {
    width: 100%;
    height: calc(100vh - 55px);
    display: flex;
    flex-direction: column;
    background-color: #fff;
    border-radius: 24px 24px 0 0;
    padding: 16px;
    overflow: auto;
    .productInfo {
      display: flex;
      align-items: center;
      margin-bottom: 10px;
      .orderIcon {
        width: 38px;
        height: 38px;
        margin-right: 10px;
      }
      .productName {
        color: #000000;
        font-size: 14px;
        font-weight: 500;
      }
    }
    .loanDetails {
      background-color: #EBEBFE;
      padding: 16px;
      border-radius: 10px;
      .box-name {
        color: #000004;
        font-size: 14px;
        font-weight: 500;
        text-align: left;
        margin-bottom: 12px;
      }
      .numBox {
        display: flex;
        justify-content: space-between;
        margin-bottom: 20px;
        .num-left {
          width: 130px;
          text-align: left;
          font-size: 14px;
          color: #999999;
        }
        .num-right {
          flex: 1;
          text-align: right;
          word-wrap: break-word; /* 使用 word-wrap */
          font-weight: bold;
          font-size: 14px;
          color: #000000;
        }
      }
      .loanAgreement {
        color: #4A44C6;
        font-size: 14px;
        font-weight: bold;
        text-decoration-line: underline;
        text-align: right;
      }
    }
    .bottom-btn {
      margin-top: 20px;
      width: 100%;
      height: 50px;
      background: #4A44C6;
      border-radius: 25px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-weight: 500;
      font-size: 16px;
      color: #ffffff;
    }
  }
}
</style>